import {useEffect, useRef, useState} from "react";
import {useHistory, useLocation} from "react-router-dom";
import {isValidTan} from "../component/form/TanInput";

export const readTanPrefill = (search) => {
    const values = new URLSearchParams(search).getAll("tan");
    return (values.length === 1 && isValidTan(values[0])) ? values[0] : "";
};

// Capture at page level so asynchronous loading/contact details cannot lose the prefill.
export const useTanPrefill = () => {
    const location = useLocation();
    const history = useHistory();
    const [tan, setTan] = useState(() => readTanPrefill(location.search));
    const pathname = useRef(location.pathname);

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        if (params.has("tan") || pathname.current !== location.pathname) {
            setTan(readTanPrefill(location.search));
            pathname.current = location.pathname;
        }
        if (params.has("tan")) {
            params.delete("tan");
            const search = params.toString();
            history.replace({...location, search: (search ? `?${search}` : "")});
        }
    }, [history, location]);

    return tan;
};
